  $(document).ready(function() {
  // Handle click on menu items
  $('.mobile-mega-menu li').click(function(e) {
    // e.preventDefault();

    var targetId = $(this).attr('id');
    var targetBox = $('#' + targetId + '.mega-menu.collc-box');
    var mobileMenu = $('.nws-custom-mobile-menu');

    if (targetBox.hasClass('active')) {
      targetBox.removeClass('active');
      mobileMenu.removeClass('active');
    } else {
      $('.mega-menu.collc-box').removeClass('active');
      targetBox.addClass('active');

      mobileMenu.addClass('active');
    }
  });

  // Close menu when h4 inside is clicked
  $('.mega-menu.collc-box .collection-list h4').click(function(e) {
    var parentBox = $(this).closest('.mega-menu.collc-box');
    parentBox.removeClass('active');
    $('.nws-custom-mobile-menu').removeClass('active');
  });
});


 // Open Sidebar
$(".nws-icon-open").click(function () {
    $(".nws-custom-mobile-menu").addClass("open");
    $(".nws-custom-mobile-overlay").addClass("menu-sidebar-active");
});

// Close Sidebar
$(".menu-toggle-close").click(function () {
    $(".nws-custom-mobile-menu").removeClass("open");
    $(".nws-custom-mobile-overlay").removeClass("menu-sidebar-active");
});

// Close sidebar when clicking outside
$(document).click(function (event) {
    if (!$(event.target).closest(".nws-custom-mobile-menu, .nws-icon-open").length) {
        $(".nws-custom-mobile-menu").removeClass("open");
        $(".nws-custom-mobile-overlay").removeClass("menu-sidebar-active");
    }
});
  
  jQuery('.slide-testimonial').slick({
        dots: true,
        arrows: false,
        infinite: true,
        slidesToShow: 1,
        centerMode: true,
        slidesToScroll: 1,
        responsive: [
         {
          breakpoint: 1171,
          settings: {
              dots: true,
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1
          }
         },{
            breakpoint: 1050,
            settings: {
                dots: true,
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },{
            breakpoint: 800,
            settings: {
                dots: true,
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },{
        breakpoint: 600,
        settings: {
            dots: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1
        }
    }]
  });


jQuery(document).ready(function () {
    if (jQuery('.big_slide').length && jQuery('.min_slide_root').length) {
        initializeSliders();
    } else {
        console.error('One or both slider elements are missing!');
    }
});

function initializeSliders() {
    jQuery('.big_slide').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        draggable: false,
        touchMove: false,
        swipeToSlide: false,
        focusOnSelect: false,
        fade: false,
        autoplay: true,
        autoplaySpeed: 8000,
        asNavFor: '.min_slide_root'
    });
    jQuery('.min_slide_root').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.big_slide',
        arrows: false,
        autoplay: true,
        autoplaySpeed: 8000,
        touchMove: true,
        dots: false,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 1281,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 835,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 481,
                settings: {
                    dots: false,
                    arrows: false,
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 415,
                settings: {
                    dots: false,
                    arrows: false,
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    });
}
try {
    jQuery('.big_slide').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        draggable: false,
        touchMove: false,
        swipeToSlide: false,
        focusOnSelect: false,
          autoplay: true,
        autoplaySpeed: 8000,
        fade: false,
        asNavFor: '.min_slide_root'
    });
} catch (error) {
    console.error('Error initializing .big_slide slider:', error);
}

try {
    jQuery('.min_slide_root').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.big_slide',
        arrows: false,
          autoplay: true,
        autoplaySpeed: 8000,
        touchMove: true,
        dots: false,
        focusOnSelect: true,
        responsive: [
            // Your responsive settings
        ]
    });
} catch (error) {
    console.error('Error initializing .min_slide_root slider:', error);
}


      // Hide all answers initially
    jQuery('.faq-answer').hide();

    // Show first answer
    jQuery('.faq-item').first().addClass('active-drop').find('.faq-answer').show();

    // Toggle on click
    jQuery('.faq-item').click(function () {
        if (jQuery(this).hasClass('active-drop')) {
            jQuery(this).removeClass('active-drop').find('.faq-answer').slideUp();
        } else {
            jQuery('.faq-item').removeClass('active-drop').find('.faq-answer').slideUp();
            jQuery(this).addClass('active-drop').find('.faq-answer').slideDown();
        }
    });


    function toggleHeaderClass() {
    if (jQuery(window).scrollTop() > 60) {
        jQuery(".ud-header").addClass("fix_top");
    } else {
        jQuery(".ud-header").removeClass("fix_top");
    }
}

// Run on scroll
jQuery(window).on("scroll", toggleHeaderClass);

// Run on page load
jQuery(document).ready(function() {
    toggleHeaderClass();
});